import { render, staticRenderFns } from "./Detalles.vue?vue&type=template&id=7acb7250&scoped=true"
import script from "./Detalles.vue?vue&type=script&lang=js"
export * from "./Detalles.vue?vue&type=script&lang=js"
import style0 from "./Detalles.vue?vue&type=style&index=0&id=7acb7250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acb7250",
  null
  
)

export default component.exports